

















import { CharacterParameter } from '@/types/statusBoard';
import { defineComponent, PropType, computed, SetupContext } from '@vue/composition-api';

export default defineComponent({
  
  props: {
    parameter: { type: Object as PropType<CharacterParameter>, required: true }
  },

  setup (props, ctx: SetupContext) {

    const parcentage = computed(() => props.parameter.max === 0 ? 0 : Math.ceil(props.parameter.current / props.parameter.max * 100));

    function select (): void {
      ctx.emit('select', props.parameter.name);
    }

    return {
      parcentage,
      select
    };
  }
});
